import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { BaseButton, Spinner, Tooltip, Variables } from '../base';

interface IIconContainerProps {
    backgroundColor?: string;
}

export const AttachmentButton = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 13px;

    min-width: 275px;
    max-width: 365px;

    background-color: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;

    transition: all 0.2s ease-in;

    &:not(:first-of-type) {
        margin-top: 8px;
    }

    &:hover {
        border-color: ${Variables.Colors.n30};
        cursor: pointer;
    }
`;

export const AttachmentImage = styled.div`
    display: inline-flex;
    max-width: 365px;

    border-radius: ${Variables.Rounded.medium};
    border: ${Variables.Borders.regular};
    border-color: ${Variables.Colors.n15};

    &:not(:first-of-type) {
        margin-top: 16px;
    }

    &:hover {
        border-color: ${Variables.Colors.n30};
        cursor: pointer;
    }
`;

export const AttachmentThumbnail = styled.img``;

export const IconContainer = styled.div<IIconContainerProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background-color: ${(props: IIconContainerProps) => props.backgroundColor || '#f1f5f9'};
    flex-shrink: 0;
    
    svg {
        width: 16px;
        height: 16px;
    }
`;

export const PaperclipIcon = styled(Icon)`
    fill: ${Variables.Colors.n30};
    transform: rotate(45deg);
`;

export const AttachmentLabels = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;

    font-size: 14px;
    letter-spacing: 0.2px;

    margin-left: 12px;
`;

export const AttachmentFilename = styled.div`
    color: #1e293b;
    font-weight: 500;
    margin-bottom: 2px;
    line-height: 20px;

    text-overflow: ellipsis;
    overflow: hidden;
`;

export const AttachmentSize = styled.div`
    color: #64748b;
    font-size: 12px;
    line-height: 16px;
`;

export const CloseIcon = styled(Icon)`
    fill: ${Variables.Colors.n50};
`;

export const IconButton = styled(BaseButton)`
    margin-left: 12px;
    padding: 0;
    background: none;
    min-width: 0;
    width: 24px;
    height: 24px;
    border: none;
    &:hover {
        svg {
            fill: ${Variables.Colors.n30};
        }
    }
`;

export const DownloadSpinner = styled(Spinner)`
    svg {
        fill: ${Variables.Colors.n30};
    }
`;

export const StyledTooltip = styled(Tooltip)`
    cursor: pointer;
`;

export const EditIcon = styled(Icon)`
    fill: ${Variables.Colors.n50};
`;

export const DownloadIcon = styled(Icon)`
    fill: ${Variables.Colors.n50};
`;